import { INavigationClient, NavigationOptions } from "@azure/msal-browser"
import { navigate } from "gatsby"

/**
 * MSAL's INavigationClient, routed through Gatsby so internal redirects stay
 * client-side.
 *
 * Implemented as a plain object rather than a subclass of msal-browser's
 * NavigationClient: that is a native ES2015 class, and Gatsby's Babel targets
 * downlevel our code to ES5, which makes `extends` throw at construction time.
 */
export const gatsbyNavigationClient: INavigationClient = {
  async navigateInternal(url: string, options: NavigationOptions) {
    const relativePath = url.replace(window.location.origin, "")
    await navigate(relativePath, { replace: Boolean(options.noHistory) })

    return false
  },

  async navigateExternal(url: string, options: NavigationOptions) {
    if (options.noHistory) {
      window.location.replace(url)
    } else {
      window.location.assign(url)
    }

    // The browser navigation is async, so hold the promise open the way MSAL's
    // own default client does instead of resolving into a half-torn-down page.
    return new Promise<boolean>(resolve =>
      setTimeout(() => resolve(true), options.timeout)
    )
  },
}
